import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Layout } from './components/Layout';
import { Spinner } from './components/ui';
import { LoginPage } from './pages/Login';
import { SignupPage } from './pages/Signup';
import { ForgotPasswordPage } from './pages/ForgotPassword';
import { DispatchPage } from './pages/Dispatch';
import { JobsPage } from './pages/Jobs';
import { JobDetailPage } from './pages/JobDetail';
import { CallsPage } from './pages/Calls';
import { CustomersPage } from './pages/Customers';
import { CustomerDetailPage } from './pages/CustomerDetail';
import { EstimatesPage } from './pages/Estimates';
import { EstimateDetailPage } from './pages/EstimateDetail';
import { InvoicesPage } from './pages/Invoices';
import { InvoiceDetailPage } from './pages/InvoiceDetail';
import { ReportsPage } from './pages/Reports';
import { PriceBookPage } from './pages/PriceBook';
import { ImportPage } from './pages/Import';
import { SettingsPage } from './pages/Settings';
import { AdminPage } from './pages/Admin';

export function App() {
  const { status } = useAuth();

  if (status === 'loading') {
    return (
      <div className="grid h-full place-items-center text-ink-3">
        <Spinner className="size-6" />
      </div>
    );
  }

  if (status === 'anonymous') {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/dispatch" replace />} />
        <Route path="/dispatch" element={<DispatchPage />} />
        {/* Crewlark staff only; the server 404s it for everybody else. */}
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/jobs/:id" element={<JobDetailPage />} />
        <Route path="/calls" element={<CallsPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/customers/:id" element={<CustomerDetailPage />} />
        <Route path="/estimates" element={<EstimatesPage />} />
        <Route path="/estimates/:id" element={<EstimateDetailPage />} />
        <Route path="/invoices" element={<InvoicesPage />} />
        <Route path="/invoices/:id" element={<InvoiceDetailPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/pricebook" element={<PriceBookPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/import" element={<ImportPage />} />
      </Route>
      <Route path="/login" element={<Navigate to="/dispatch" replace />} />
      <Route path="*" element={<Navigate to="/dispatch" replace />} />
    </Routes>
  );
}
